<template>
  <component
    :is="componentType"
    :avatar="avatar"
    :members="members"
    :is-loading="isLoadingMembers"
    :is-disabled="isPerformingAction"
    @hang-up="onHangUp"
    @go-back="$emit('go-back')"
    @close="$emit('close')"
  />
</template>

<script lang="ts">
import { Component } from 'vue';
import { defineComponent, PropType } from 'vue-demi';

import AppDialerCallMembersPopup from '../../components/popups/AppDialerCallMembersPopup.vue';
import AppDialerCallMembersPage from '../../components/pages/AppDialerCallMembersPage.vue';
import {
  useCommonProps,
  useDialerStore,
  useConferenceMembersActions,
} from '../../composables';

export default defineComponent({
  name: 'AppDialerCallMembersContainer',
  components: {
    AppDialerCallMembersPopup,
    AppDialerCallMembersPage,
  },
  props: {
    component: {
      type: String as PropType<'popup' | 'page'>,
      default: 'popup',
    },
  },
  emits: ['go-back', 'close'],
  setup() {
    const { avatar } = useCommonProps();
    const {
      isLoadingMembers,
      isPerformingAction,
      members,
    } = useDialerStore();
    const { onHangUp } = useConferenceMembersActions();

    return {
      avatar,
      members,
      isLoadingMembers,
      isPerformingAction,
      onHangUp,
    };
  },
  computed: {
    componentType(): Component {
      switch (this.component) {
        case 'page':
          return AppDialerCallMembersPage;
        case 'popup':
        default:
          return AppDialerCallMembersPopup;
      }
    },
  },
});
</script>
